export const constant = {
  base_url1: "https://xeniaqlaunch.onrender.com/api",

  base_url2: "https://tokendev.bpos.in/api/",

  // base_url: "https://xeniatokenapi.onrender.com/api",

  image_upload_url: "https://apiimage.xeniapos.com/TMS/image/upload",
  image_render_url:
    "https://apiimage.xeniapos.com/TMS/assest/uploads?fileName=",
  vedio_upload_url: "https://apiimage.xeniapos.com/TMS/video/upload",
};


